import { ref } from 'vue'

export default defineNuxtPlugin((nuxtApp) => {
  const isLoading = ref(true)

  // app:mounted means the app is on screen behind the loader, so reveal it.
  nuxtApp.hook('app:mounted', () => {
    isLoading.value = false
  })

  // Show loader when page starts loading
  nuxtApp.hook('page:start', () => {
    isLoading.value = true
  })

  // Hide loader when page finishes loading
  nuxtApp.hook('page:finish', () => {
    isLoading.value = false
  })

  return {
    provide: {
      isLoading
    }
  }
})
